import React, { CSSProperties } from 'react'
import Button from './Button'
import Picture from './Picture'
import RelicIcon from './RelicIcon'

interface Props {
    user: {displayName: string | null, photoURL: string | null};
    onSignout: () => void
}

function Header(props: Props) {
    const cssProps: CSSProperties = {
        gridTemplateColumns: 'repeat(2, max-content)'
    }
    return <header className="bg-gray-200 flex justify-between shadow-md">
        <h1 className="text-4xl">
            <span role="img" aria-hidden="true" className="m-3">🥔</span>
        </h1>
        <div className="grid gap-1 p-1" style={cssProps}>
        {
            props.user.photoURL ? 
            <Picture src={props.user.photoURL} alt={props.user.displayName!} /> : 
            <RelicIcon className="h-12 w-12" name={props.user.displayName!} />
        }
        <Button color="danger" onClick={props.onSignout}>Sign out</Button>
        </div>
    </header>
}


export default Header
